const sharePointHostSuffixes = [
    'sharepoint.com',
    'sharepoint.cn',
    'sharepoint.de',
    'sharepoint.us',
    'sharepoint-mil.us'
] as const;

export function isSharePointUrl(value: string | undefined): boolean {
    if (value == null) {
        return false;
    }

    try {
        const url = new URL(value);
        const hostname = url.hostname.toLocaleLowerCase().replace(/\.$/, '');

        return url.protocol === 'https:'
            && sharePointHostSuffixes.some((suffix) => hostname.endsWith(`.${suffix}`));
    } catch {
        return false;
    }
}